import { v4 as uuid } from 'uuid'

import api from '@/api'

import { Distribution } from './constants'
export default {
  namespaced: true,
  state: {
    types: [],
    fertigation: false,
    applications: []
  },
  mutations: {
    setTypes (state, types) {
      if (!Array.isArray(types)) {
        throw new Error('Invalid irrigation list')
      }
      state.types = types
    },
    setFertigation (state, fertigation) {
      if (![true, false].includes(fertigation)) {
        throw new Error(`Invalid fertigation value ${fertigation}`)
      }
      state.fertigation = fertigation
      if (state.applications.length > 0 && fertigation) {
        for (const application of state.applications) {
          application.distribution = Distribution.ONE_TIME
        }
      }
    },
    addApplication (state, { fertilizer, distribution, rate, date, fromDate, toDate, every }) {
      const id = uuid()
      const found = state.types.find((current) => current.id === fertilizer)
      if (!found) {
        throw new Error(`Invalid irrigation ${fertilizer}`)
      }
      const newApplication = {
        id,
        fertilizer: found.id,
        distribution,
        rate,
        date,
        fromDate,
        toDate,
        every
      }
      state.applications.push(newApplication)
    },
    updateApplication (state, { index, fertilizer, distribution, rate, date, fromDate, toDate, every }) {
      const application = state.applications[index]
      if (fertilizer) {
        const found = state.types.find((current) => current.id === fertilizer)
        if (!found) {
          throw new Error(`Invalid irrigation ${fertilizer}`)
        }
        application.fertilizer = found.id
      }

      if (rate) {
        application.rate = rate
      }

      // If we change distribution, then we change
      // application.distribution.
      if (distribution) {
        application.distribution = distribution
      } else {
        distribution = application.distribution
      }

      // This is used only if it is a one-time thing.
      if (date && distribution === Distribution.ONE_TIME) {
        application.date = date
      }

      // This is used only if it is a periodical thing.
      if (fromDate && distribution === Distribution.PERIODICAL) {
        application.fromDate = fromDate
      }
      if (toDate && distribution === Distribution.PERIODICAL) {
        application.toDate = toDate
      }
      if (every && distribution === Distribution.PERIODICAL) {
        application.every = every
      }

      state.applications.splice(index, 1, application)
    },
    removeApplication (state, index) {
      const [removed] = state.applications.splice(index, 1)
      console.log('Removed: ' + removed)
    }
  },
  actions: {
    async loadTypes ({ commit }) {
      const types = await api.loadIrrigationMethods()
      commit('setTypes', types)
    }
  }
}
